<template>
    <div>
        <el-tooltip
            :placement="props.placement"
            trigger="hover"
            effect="light"
            :disabled="props.names.length === 1"
        >
            <template #content>
                <span class="userList">
                    <span
                        v-for="(item, index) in props.names"
                        :key="index"
                        class="user"
                        @click="openUserDialog(index)"
                    >
                        {{ item }}
                    </span>
                </span>
            </template>
            <div class="slotSpan">
                <slot />
            </div>
        </el-tooltip>
        <el-dialog
            :key="state.key + 1"
            v-model="state.dialogUserVisible"
            width="800px"
            top="6%"
            append-to-body
            :title="`${state.selectInfo.name}负责的任务`"
            :before-close="handleClose"
        >
            <UserTask :id="state.selectInfo.id" />
        </el-dialog>
    </div>
</template>

<script setup>
import UserTask from '@/views/Task/waitDeal/Modal/UserTask.vue';
import { reactive } from 'vue';

const props = defineProps({
    ids: {
        type: Array,
        default: () => []
    },
    names: {
        type: Array,
        default: () => []
    },
    placement: {
        type: String,
        default: () => 'bottom'
    }
});

const state = reactive({
    key: new Date().getTime(),
    dialogUserVisible: false,
    selectInfo: {}
});

const openUserDialog = (index) => {
    state.selectInfo = {
        name: props.names[index],
        id: props.ids[index]
    };
    state.dialogUserVisible = true;
};

const handleClose = () => {
    state.key = new Date().getTime();
    state.dialogUserVisible = false;
};

</script>

<style lang="scss" scoped>
.userList {
    display: flex;
    align-items: center;
    .user {
        margin-right: 10px;
        color: #179AEE;
        cursor: pointer;
    }
}
.slotSpan {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    color: #179AEE;
}
</style>
